import { useState } from "react";
import { device } from "web_myplann/Utils/device";
import type { NavigationType } from "web_myplann/Utils/WebViewModel";

export const useOpenCalculator = () => {
	const [isOpeningCalculator, setIsOpeningCalculator] = useState(false);

	const openCalculator = async (type: NavigationType): Promise<void> => {
		setIsOpeningCalculator(true);
		try {
			await device.navigationRequest(type);
		} catch {
		} finally {
			setIsOpeningCalculator(false);
		}
	};

	return { openCalculator, isOpeningCalculator };
};
